import LandingV3 from "./LandingV3";

export default LandingV3;
